import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateReturnInsights = {
  name: "generateReturnInsights" as const,
  input: z.object({
    teamId: zExt.objectId(),
    startDate: z.string().describe("ISO date string for analysis start date"),
    endDate: z.string().describe("ISO date string for analysis end date"),
    ownerTeamId: zExt
      .objectId()
      .optional()
      .describe(
        "Optional team ID to assign report ownership (defaults to teamId)",
      ),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().optional(),
    error: z.string().optional(),
  }),
};
